import {
  Box,
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { getCompanyLanguage } from '../../api/company';
import { consumeMagicLoginToken } from '../../api/magicLogin';
import { currentUser } from '../../api/user';
import Logo from '../../components/Nav/TopNav/Logo';
import { Copyright } from '../../components/SignInForm';
import { setCurrentUser } from '../../store/user/actionCreators';
import { changeLocale } from '../LanguageProvider/actions';
import messages from './messages';

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  logo: {
    margin: '18px'
  },
  status: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    textAlign: 'center'
  },
  signInButton: {
    margin: theme.spacing(3, 0, 2)
  }
}));

export function MagicLoginPage({ dispatch }) {
  const classes = useStyles();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const token = new URLSearchParams(location.search).get('token');
    if (!token) {
      setFailed(true);
      return;
    }

    // The consume response is a UserDetailsDto, which carries no
    // companyDetails — the gated pages behind `/` read
    // user.companyDetails.pricingSubscription and throw without it. So the
    // store has to be filled from /user/me, exactly as signing in does, and
    // only then may we leave this page: landing on a private route before the
    // user is in the store bounces straight back out to /signin.
    consumeMagicLoginToken(token)
      .then(() => currentUser())
      .then(res => {
        dispatch(setCurrentUser(res.data.data));
        return getCompanyLanguage()
          .then(language => dispatch(changeLocale(language)))
          .catch(() => {});
      })
      .then(() => history.replace('/'))
      .catch(() => setFailed(true));
  }, []);

  return (
    <Container component="main" maxWidth="xs">
      <Helmet>
        <title>
          {intl.formatMessage(failed ? messages.invalidLink : messages.signingIn)}
        </title>
      </Helmet>
      <CssBaseline />
      <div className={classes.paper}>
        <div className={classes.logo}>
          <Logo />
        </div>
        <div className={classes.status}>
          {failed ? (
            <>
              <Typography variant="body1">
                {intl.formatMessage(messages.invalidLink)}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {intl.formatMessage(messages.requestNewLink)}
              </Typography>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.signInButton}
                onClick={() => history.push('/signin')}
              >
                {intl.formatMessage(messages.goToSignIn)}
              </Button>
            </>
          ) : (
            <>
              <CircularProgress size={28} />
              <Typography variant="body1">
                {intl.formatMessage(messages.signingIn)}
              </Typography>
            </>
          )}
        </div>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
}

export default connect()(MagicLoginPage);
